import { type schemaType } from '~~/shared/api/rurality/v2/cottages/recommended/schema'
import { type paramsType } from '~~/shared/api/rurality/v2/cottages/recommended/paramsSchema'

export type returnType = ApiServerResponse<schemaType>

export default async (params: paramsType): Promise<returnType> => {
  const { $v2ApiNuxtEndpointPostPlugin } = useNuxtApp()

  const data = await $v2ApiNuxtEndpointPostPlugin(
    'rurality/v2/cottages/recommended',
    params,
  )

  return data as returnType
}
